export default function timecodeSeconds (timecode) {
  return timecode
    // HH:MM:SS.uu => [SS.uu, MM, HH]
    .split(':').reverse()
    // [SS.uu, MM, HH] => 000000.000
    .reduce((sum, part, index) => {
      return sum + parseFloat(part, 10) * Math.pow(60, index);
    }, 0);
};
